<template>
  <h1 v-t="'pages.index.title'" />
</template>

<script>
export default {
  name: 'AdminIndexPage',
};
</script>
